import React, { useEffect, useState } from "react";
import "./Experience.scss";
import { ClockCircleTwoTone, EditOutlined } from "@ant-design/icons";
import { TUserSectionProp } from "@utils/Interfaces";
import { Empty, Skeleton, Timeline } from "antd";
import Helpers from "@utils/Helpers";

const Experience: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
  loading,
}) => {
  const [companyExps, setCompanyExps] = useState<any[]>([]);

  useEffect(() => {
    if (userProfile.experience!.length > 0) {
      const experienceItems: any[] = [];
      userProfile.experience?.forEach((item: any, index) => {
        const expItem = {
          children: (
            <div className="exp-item" key={index}>
              <div className="exp-company">{item.company_name}</div>
              <div className="exp-company-working-time">
                <ClockCircleTwoTone twoToneColor={"#52b4b4"} className="me-1" />
                {Helpers.formattedDate(item.company_start_date)} -{" "}
                {Helpers.formattedDate(item.company_end_date)}
              </div>
              {item.position.map((ite: any, idx: any) => (
                <PositionItem key={idx} data={ite} index={idx} />
              ))}
            </div>
          ),
          color: "#52b4b4",
        };
        experienceItems.push(expItem);
      });
      setCompanyExps(experienceItems);
    }
  }, [userProfile]);

  return (
    <div className="card card-profile experience">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("3");
        }}
      >
        <EditOutlined />
      </div>
      <div className="card-title">Experience</div>
      <div className="exp-description">
        <div className="d-flex flex-column gap-2">
          {!loading ? (
            <Skeleton active />
          ) : userProfile.experience?.length == 0 ||
            userProfile.experience == null ? (
            <Empty />
          ) : (
            <Timeline items={companyExps} />
          )}
        </div>
      </div>
    </div>
  );
};

const PositionItem: React.FC<any> = ({ data, index }) => {
  return (
    <div className="exp-position-item" key={index}>
      <div className="exp-position">{data.position_name}</div>
      <div className="exp-working-time">
        <ClockCircleTwoTone twoToneColor={"#52b4b4"} className="me-1" />
        {Helpers.formattedDate(data.start_date)} -{" "}
        {Helpers.formattedDate(data.end_date)}
      </div>
      <ul className="exp-description">
        <li>{data.description}</li>
      </ul>
      <div className="exp-skills">
        {data.skills?.map((item: any, index: any) => {
          return (
            <div className="exp-skill-item" key={index}>
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Experience;
